import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RemoveCircle, CheckCircle, Store } from '@mui/icons-material';
import { GetCurrentTenantDocument, GetOrganizationsDocument } from '@/generated/root-types';
import { useLazyQuery, useQuery } from '@apollo/client/react';

const Organizations: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: currentTenantData } = useQuery(GetCurrentTenantDocument);
  const [getOrganizations, { data, loading }] = useLazyQuery(GetOrganizationsDocument, {});
  const organizations = data?.organizations?.nodes ?? [];

  useEffect(() => {
    if (currentTenantData?.currentTenant?.id) {
      getOrganizations({
        variables: { first: 50, tenantId: currentTenantData?.currentTenant?.id ?? null },
      });
    }
  }, [currentTenantData, getOrganizations]);

  return (
    <Box>
      {loading ? (
        <Typography>{t('Loading...')}</Typography>
      ) : (
        <Grid container spacing={3}>
          {organizations.map((organization) => {
            return (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={String(organization.id)}>
                <Card
                  elevation={2}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      boxShadow: 4,
                      transform: 'translateY(-2px)',
                      transition: 'all 0.2s ease-in-out',
                    },
                  }}
                  onClick={() => navigate(`/reseller-organizations/${organization.id}`)}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 2,
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        <Store sx={{ mr: 1, color: 'primary.main' }} />
                        <Typography variant="h6" component="div" sx={{ flex: 1 }}>
                          {organization.name}
                        </Typography>
                        {organization.status === 'ACTIVE' ? (
                          <CheckCircle color="success" sx={{ fontSize: 20 }} />
                        ) : (
                          <RemoveCircle color="error" sx={{ fontSize: 20 }} />
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

export default Organizations;
